var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ManagerTasksDashboard"},[_c('CRow',[_c('CCol',[_c('h1',[_vm._v(" Aide - Rôle des utilisateurs ")])])],1),_c('CCard',{staticClass:"mt-3"},[_c('CCardBody',[_c('aideRoleComponent')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }